var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1.000000, 1.000000)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"},[React.createElement("path",{"d":"M17.5,5.5 L0.5,5.5","key":0}),React.createElement("path",{"d":"M13.5,0.5 L18.5,5.5","key":1}),React.createElement("path",{"d":"M13.5,5.5 L18.5,10.5","transform":"translate(16.000000, 8.000000) scale(1, -1) translate(-16.000000, -8.000000) ","key":2})]));
}

Arrow.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 21 13","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
